export const categories = {
  "Lista kategorii": "Categories list"
};



// WEBPACK FOOTER //
// ./locales/en_US/categories.js